import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import AnimatedPieChart from "../Charts/AnimatedPieChart.jsx";
import HorizontalBarChart from "../Charts/HorizontalBarChart.jsx";
import AnimatedNumber from "react-animated-number";

import DecorImage from "../Media/decor.png";
import DecorUpImage from "../Media/decorUp.png";
import BackgroundImage from "../Media/back8.jpg";

const styles = theme => ({
  media: {
    height: "auto"
  },
  card: {
    background: "rbga(255, 255,255,0.5)"
  },
  chartDiv: {
    position: "relative",
    height: "50vh"
  },
  chartCard: {
    backgroundColor: theme.palette.textBox,
    margin: 20,
    padding: 20,
    borderRadius: 20,
    display: "inline-block"
  },
  barChartCard: {
    backgroundColor: theme.palette.textBox,
    margin: 20,
    padding: 20,
    borderRadius: 20,
    display: "inline-block",
    height: 700,
    minWidth: "40%"
  },
  cardHeader: {
    backgroundColor: theme.palette.white70
  },
  decorUpImage: {
    marginBottom: "-5px"
  },
  title: { padding: 20 }
});

function LastRaceStatsCard(props) {
  const { classes, data, runners, date, totalDistance } = props;

  var categoryLabels = data.categoryData.labels;
  var categorySeries = data.categoryData.series;
  var genderSeries = data.genderData.series;
  var genderLabels = data.genderData.labels;
  var noShowPrec = 0;
  const sum = genderSeries[0] + genderSeries[1];
  categoryLabels.forEach((row, index) => {
    if (row.indexOf("undefined") !== -1) {
      categoryLabels.splice(index, 1);
      categorySeries.splice(index, 1);
      noShowPrec = Number(row.split(" ")[1].split("%")[0]);
      genderLabels.push(`n/a ${noShowPrec}%`);
    }
  });

  genderSeries.push(Math.round((1 - (100 - noShowPrec) / 100) * sum));

  // const last = genderSeries.length - 1
  // var sum = 0
  // genderSeries.forEach((g, index) => {
  //  if (index < last) {
  //    sum += g
  //  } else {
  //    genderSeries[last] = genderSeries[last] - sum
  //  }
  // })

  return (
    <Card className={classes.card}>
      <CardMedia className={classes.media} image={BackgroundImage}>
        <img src={DecorImage} alt={"DecorImage"} />
        <CardHeader title={<i>{date}</i>} className={classes.cardHeader} />
        <CardContent>
          <Grid container>
            <Grid item xs={12} md={6}>
              <Grid container>
                <Grid item xs={12} md={12}>
                  <Card className={classes.chartCard}>
                    <CardContent>
                      <Typography variant="h5" className={classes.h5}>
                        <AnimatedNumber
                          value={totalDistance * 5 || 0}
                          duration={8000}
                          stepPrecision={0}
                        />
                        {` KM on course`}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Card className={classes.chartCard}>
                    <CardContent>
                      <Typography variant="h5" className={classes.h5}>
                        <AnimatedNumber
                          value={runners}
                          duration={8000}
                          stepPrecision={0}
                        />
                        {` Runners this week`}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Card className={classes.chartCard}>
                    <CardContent>
                      <Typography variant="h5" className={classes.h5}>
                        {"Average times: "}
                      </Typography>
                      <Typography variant="subtitle1">
                        <ul>
                          <li>{`Females: ${
                            data.genderData.averageTimes[1]
                          }`}</li>
                          <li>{`Males: ${data.genderData.averageTimes[0]}`}</li>
                        </ul>
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Card className={classes.chartCard}>
                    <CardContent>
                      <Typography variant="h5">
                        {"Gender Distribution"}
                        <AnimatedPieChart
                          series={genderSeries}
                          labels={genderLabels}
                        />
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card style={{ width: "100%" }}>
                <CardContent
                  className={classes.barChartCard}
                  style={{ minWidth: "80%" }}
                >
                  <Typography variant="h5" className={classes.title}>
                    {"Category Participation"}
                    <HorizontalBarChart
                      series={categorySeries}
                      labels={categoryLabels}
                    />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          {/*<Button size="small" color="primary">
          Share
        </Button>*/}
        </CardActions>
        <img
          src={DecorUpImage}
          alt={"DecorUp"}
          className={classes.decorUpImage}
        />
      </CardMedia>
    </Card>
  );
}

LastRaceStatsCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(LastRaceStatsCard);
